import type { Router } from 'vue-router'

export function installPageTitles(router: Router) {
  router.afterEach((to, _from, failure) => {
    if (failure) return
    const title = typeof to.meta.title === 'function' ? to.meta.title(to) : to.meta.title
    document.title = typeof title === 'string' && title.trim() ? `${title} | GO2Train` : 'GO2Train'
  })
}
